module.exports = __webpack_public_path__ + "1642699981952/static/media/authBastaoVerde.4d948fe0.svg";